var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<ng-form name=\"vm.lbTripOptionsHotelForm\" class=\"lbTripOptionsHotelForm\">\n<div ng-repeat=\"search in vm.searches track by $index\">\n<lb-trip-options-hotel-form-item search=\"search\" is-last=\"$last\" index=\"$index\">\n</lb-trip-options-hotel-form-item>\n</div>\n</ng-form>";
var id1="components/lbTripOptionsModal/lbTripOptionsHotelForm.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbTripOptionsModal/lbTripOptionsHotelForm.html
// module id = 1242
// module chunks = 1